import { gql } from '@apollo/client';

export const DeleteMe = gql`
  mutation DeleteMe {
    deleteMe
  }
`;
